<script>
import NoticeView from './NoticeView.vue'

export default {
  name: 'NoticePopup',
  components: {
    NoticeView
  },
  props: {
    notice: {
      type: Object,
      default: function () {
        return {}
      }
    },
    userInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    userRole: {
      type: Number,
      default: null
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    showTodayOption: {
      type: Boolean,
      default: true
    },
    modalName: {
      type: String,
      default: 'noticePopup'
    },
    onEdit: {
      type: Function,
      default: null
    },
    onDelete: {
      type: Function,
      default: null
    },
    onTogglePopup: {
      type: Function,
      default: null
    }
  },
  data () {
    return {
      checkedToday: false,
      localNotice: Object.assign({}, this.notice),
      processing: false
    }
  },
  watch: {
    notice: {
      deep: true,
      handler (value) {
        this.localNotice = Object.assign({}, value)
      }
    }
  },
  methods: {
    closePopup () {
      if (this.checkedToday && this.localNotice.noticePid) {
        localStorage.setItem(this.getStorageKey(this.localNotice.noticePid), String(this.getNextMidnightTime()))
      }
      this.$modal.hide(this.modalName)
    },
    getStorageKey (noticePid) {
      const userPid = this.userInfo.userPid || 'anonymous'
      return 'notice_hide_today_' + userPid + '_' + noticePid
    },
    getNextMidnightTime () {
      const date = new Date()
      date.setHours(24, 0, 0, 0)
      return date.getTime()
    },
    editNotice () {
      if (typeof this.onEdit === 'function') this.onEdit(this.localNotice)
    },
    deleteNotice () {
      if (typeof this.onDelete !== 'function') return
      this.processing = true
      const result = this.onDelete(this.localNotice)

      if (result && typeof result.then === 'function') {
        result.then(() => {
          this.processing = false
        }, () => {
          this.processing = false
        })
      } else {
        this.processing = false
      }
    },
    togglePopup () {
      if (typeof this.onTogglePopup !== 'function' || this.processing) return

      const nextShow = !this.localNotice.showPopup
      this.processing = true
      const result = this.onTogglePopup(this.localNotice, nextShow)

      if (result && typeof result.then === 'function') {
        result.then(success => {
          if (success) this.$set(this.localNotice, 'showPopup', nextShow)
          this.processing = false
        }, () => {
          this.processing = false
        })
      } else {
        this.processing = false
      }
    }
  }
}
</script>

<template>
  <div id="notice_popup" class="popup_wrap">
    <div class="popup_tit">
      <div>공지사항</div>
<!--      <span class="popup_close" @click="closePopup">닫기</span>-->
    </div>
    <div class="popup_content">
      <notice-view :notice="localNotice"/>
    </div>
    <div class="popup_btn_wrap notice_popup_btn_wrap">
      <label v-if="showTodayOption" class="notice_today_check">
        <input type="checkbox" v-model="checkedToday"/>
        <span>오늘 하루 보지 않기</span>
      </label>
      <template v-if="isAdmin">
        <div
          class="btn_positive notice_btn_popup"
          :class="{ on: localNotice.showPopup }"
          @click="togglePopup"
        >
          팝업 {{ localNotice.showPopup ? 'ON' : 'OFF' }}
        </div>
        <template v-if="userRole === 1 || userInfo.userPid === localNotice.userPid">
          <div class="btn_positive notice_btn_edit" @click="editNotice">수정</div>
          <div class="btn_positive notice_btn_delete" @click="deleteNotice">삭제</div>
        </template>
      </template>
      <div class="btn_close" @click="closePopup">닫기</div>
    </div>
  </div>
</template>

<style scoped>
.notice_popup_btn_wrap {
  gap: 10px;
}

.notice_today_check {
  display: flex;
  margin: auto auto auto 0;
  color: #36414F;
  font-size: 14px;
  line-height: 22px;
  cursor: pointer;
}

.notice_today_check > input {
  width: auto;
  height: auto;
  margin: auto 8px auto 0;
}

.notice_btn_popup,
.notice_btn_edit,
.notice_btn_delete {
  width: auto !important;
  min-width: 100px;
  padding: 0 18px;
  margin: auto 0 !important;
  text-align: center;
}

.notice_btn_popup {
  margin-right: auto !important;
  background: #E33958 !important;
}

.notice_btn_popup.on {
  background: #4BA06C !important;
}

.notice_btn_edit {
  background: #3E7EFF !important;
}

.notice_btn_delete {
  background: #E33958 !important;
}

.notice_popup_btn_wrap > .btn_close {
  margin-left: 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/notice/NoticePopup.vue